export enum NeoFacetDateFieldApiEnum {
    CREATED_AT = 'CREATED_AT',
    TIMESTAMP = 'TIMESTAMP'
}
